<template>
  <v-container v-if="!isExpired">
    <v-row>
      <MobileCol>
        <LocationEnabled />
      </MobileCol>
    </v-row>
    <v-row>
      <MobileCol>
        <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
        <Article :articles="sortedArticles" :loading="isLoading" />
      </MobileCol>
    </v-row>
    <v-row>
      <MobileCol>
        <v-btn class="mt-5" block color="primary" dark
          href="https://mark.suidlanders.co.za/" target="_blank"
        >
          <v-icon class="mr-2">{{ mdiStore }}</v-icon>
          {{ $t('menu.market') }}
        </v-btn>
        <v-btn class="mt-5" block color="primary" dark
          v-for="menuItem in menuItems" :key="menuItem.name"
          :to="{ name: menuItem.pathName }"
        >
          <v-icon class="mr-2">{{ menuItem.icon }}</v-icon>
          {{ $t(menuItem.name) }}
        </v-btn>
      </MobileCol>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mdiStore } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';
import Article from '../components/Article.vue';
import LocationEnabled from '../components/LocationEnabled.vue';
import MobileCol from '../components/MobileCol.vue';
import menuItems from '../menuItems';
import appColours from '../appColours';

export default {
  name: 'AuthHome',
  components: {
    Article,
    LocationEnabled,
    MobileCol,
  },
  mixins: [appColours, loading, menuItems, org],
  data() {
    return {
      mdiStore,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isInRole', 'isExpired']),
    ...mapGetters('articles', ['sortedArticles']),
    ...mapState('articles', ['articles']),
  },
  destroyed() {
    this.$root.$off('organization.changed');
    this.$root.$off('App.appStateChange');
  },
  async created() {
    this.$log.debug('auth home created loaded');
    this.$root.$on('organization.changed', (o) => {
      this.setColours(o);
    });
    this.$root.$on('App.appStateChange', async (o) => {
      if (o) {
        await this.$nextTick();
        await this.refresh();
      }
    });
  },
  async mounted() {
    await this.$nextTick();
    await this.refresh();
  },
  methods: {
    ...mapActions('auth', ['REFRESH_auth']),
    ...mapActions('articles', ['LOAD_articles']),
    ...mapActions('mapItems', ['LOAD_myLocation']),
    ...mapActions('organizations', ['LOAD_organizations']),
    async refreshAuth() {
      try {
        await this.REFRESH_auth();
      } catch (error) {
        this.$log.error(error);
      }
    },
    async refresh() {
      this.isLoading = true;
      await this.refreshAuth();
      await this.$nextTick();
      await this.refreshAuth();
      await this.$nextTick();
      await this.refreshAuth();
      await this.$nextTick();
      // if (this.articles?.length > 0) {
      //   this.$log.info('Waiting on refresh for auth to complete');
      //   await new Promise((r) => setTimeout(r, 2000));
      // }
      await this.LOAD_articles();
      this.isLoading = false;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (pos) => {
          await this.LOAD_myLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        });
      } else {
        this.$log.error('Geolocation is not supported by this browser.');
      }
    },
  },
};

</script>
